import {MessageChannelsType} from './types/Passwordless'

type ChannelsNameType = 'WhatsApp' | 'SMS'
type ChannelsType = Record<
  MessageChannelsType,
  {
    name: ChannelsNameType
    enabled: boolean
  }
>

export const LOGIN_CALLBACK_ROUTE = '/passwordless/callback'
export const COGNITO_LOGIN_CALLBACK_ROUTE = '/authentication/callback'
export const COGNITO_LOGOUT_CALLBACK_ROUTE = '/logout/callback'
export const WHATSAPP_KEY = 'whatsapp'
export const SMS_KEY = 'sms'
export const SILENT_AUTH_URL_TRIGGER = 'authenticate'

export const CHANNELS: ChannelsType = {
  [SMS_KEY]: {
    name: 'SMS',
    enabled: true
  },
  [WHATSAPP_KEY]: {
    name: 'WhatsApp',
    enabled: true
  }
}
